import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BnLoadingService, EntityOrderedRequestParameters, EntityPagedRequestParameters, MessageChannelService } from '@bndes/bndes-ux4/bndes-angular-utils';
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import moment from 'moment';
import { ProtocoloArquivo, STATUS_PROTOCOLO } from 'src/app/model/protocolo-arquivo.model';
import Utils from 'src/app/shared/fgi-utils';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { ProtocoloArquivoService } from 'src/app/shared/services/protocolo-arquivo.service';
import { LeilaoService } from '../../leilao.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { Subject, takeUntil } from 'rxjs';
import { ROLE_AGENTE_CONSULTA } from 'src/app/constantes/permissao.constants';

@Component({
  selector: 'app-leilao-listagem',
  templateUrl: './leilao-listagem.component.html',
  styleUrls: ['./leilao-listagem.component.scss'],
  standalone: false
})
export class LeilaoListagemComponent implements OnInit {

  @Input() protocolos: ProtocoloArquivo[];
  @Input() atributosPaginacao: EntityPagedRequestParameters;
  @Input() cnpjAgente: string;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  atributosOrdenacao: EntityOrderedRequestParameters;
  protocoloCancelamento: ProtocoloArquivo;
  public perfilAgenteTransacional: boolean = false;
  public opcoesPaginacao = [10, 25, 50];
  private readonly destroy$ = new Subject();

  @ViewChild('msgTemplateCancelarProtocolo') msgTemplateCancelarProtocolo: TemplateRef<any>;
  @ViewChild('botoesPersonalizadosCancelarProtocolo') botoesPersonalizadosCancelarProtocolo: TemplateRef<any>;

  constructor(
    private fileUtils: FileUtilsService, 
    private protocoloService: ProtocoloArquivoService,
    private loadingService: BnLoadingService,
    private messageService: MessageChannelService,
    private modalService: BnModalMessageService,
    private leilaoService: LeilaoService,
    private permissaoService: PermissaoService,
  ) { 

  }

  ngOnInit() {
    this.permissaoService.getPermissoesUsuarioAutenticado()
      .pipe(takeUntil(this.destroy$))
        .subscribe((resp: any) => {
          this.perfilAgenteTransacional = resp && resp[ROLE_AGENTE_CONSULTA];
        });
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  obterLabelStatusProtocolo(statusProtocolo: string) {
    return STATUS_PROTOCOLO.find(status => status.codigo === statusProtocolo).label;
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    let funcao = undefined;
    if (ord.atributo == 'valor') {
      funcao = parseFloat;
    }
    this.protocolos = this.protocolos.sort((a, b) => {
      if (ord.sentido == "asc") {
          return Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
      else {
          return -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
    });
  }

  downloadArquivoEnvio(idProtocoloArquivo: string) {
    this.protocoloService.getArquivoEnvio(idProtocoloArquivo).subscribe((conteudoArquivo) => {
        this.fileUtils.exportarArquivo('Arquivo_envio_' + idProtocoloArquivo + '.json',
            JSON.stringify(conteudoArquivo), FileUtilsService.APPLICATION_JSON);
    });
  } 

  downloadArquivoResposta(idProtocoloArquivo: string) {
    this.protocoloService.getArquivoResposta(idProtocoloArquivo).subscribe((conteudoArquivo) => {
        this.fileUtils.exportarArquivo('Arquivo_resposta_' + idProtocoloArquivo + '.json',
          JSON.stringify(conteudoArquivo), FileUtilsService.APPLICATION_JSON);
    }); 
  }

  podeCancelar(protocolo: ProtocoloArquivo) {
    return moment(protocolo.dataEnvio).isSame(moment(), 'day') && protocolo.statusProtocolo == 'S';
  }

  abrirCancelarProtocolo(event, protocolo: ProtocoloArquivo) {
    event.stopPropagation();
    this.protocoloCancelamento = protocolo;

    this.modalService.abrir('Confirmação',
      'Confirmar o cancelamento do protocolo selecionado.',
      'lg',
    this.msgTemplateCancelarProtocolo, this.botoesPersonalizadosCancelarProtocolo);  
  }

  cancelarProtocolo() {
    this.loadingService.bloqueiaTela();
    this.protocoloService.cancelarProtocolo(this.protocoloCancelamento.idProtocoloNegocio).subscribe(() => {
      this.cancelarProtocolo = null;
      this.close();
      this.aoMudarPagina.emit(this.atributosPaginacao);
      this.loadingService.liberaTela();
    });
  }

  public close(): void {
    this.modalService.close();
  }
}
